import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { AppState } from '../../../../../../app.service';
import { Service } from '../../../direct-connect.service';

import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../../common/global-variables';
let $ = require('jquery');
import { IpValidationUtils  } from '../../../../../../../common/validations/ip-validation-utils';

@Component({
  selector: 'configure-gateway',
  styles: [require('../../../direct-connect.scss')],
  template: require('./configure-gateway.html'),
    providers: [
    Service, TranslateService
  ]
})

export class ConfigureGateway {


  @Input() createData: any;
  @Input() isWizardOpen: boolean = false;
  @Input() stepId: number;
  @Input() networkDetail: any;
  @Input() showBusy: boolean = false;
  @Input() isNetworkCreatedNow: boolean = false;
  @Output() stepEventEmitter: EventEmitter<any> = new EventEmitter();

  private subscribeHandler;
  private isTranslationready: boolean = false;
  private ipValidationUtils: IpValidationUtils = new IpValidationUtils();
  private arrEdgesConnected: Array<any> = [];
  private htmlIPRanges: any;
  private dataModel = {
    ipRanges: [],
    isIpRangeValid: false,
	  edgeId: "",
	  edgeName: "",
    maskBits: "",
    gatewayAddress: "",
    isStepValid: false,
    stepId: -1
  };

  ngOnInit() {

  }

  ngOnChanges(changes) {
    if (!this.isWizardOpen) {
        return;
    }
    if (this.stepId >= 0) {
        this.dataModel.stepId = this.stepId;
    }
    if (this.networkDetail) {
        this.dataModel.gatewayAddress = this.networkDetail.gatewayAddress;
        this.dataModel.maskBits = this.networkDetail.maskBits;
        return;
    }
    if (this.createData && this.createData.subnets) {
        this.dataModel.ipRanges = this.createData.subnets[0].ipRanges;
    }

  }

  constructor(public appState: AppState,
            public service: Service,
            private translate: TranslateService) {
      translate.onLangChange.subscribe((event) => {
        this.isTranslationready = true;
      });
      translate.use(GlobalVariables.LOCALE);
   }

  transitFormValid(event) {
    this.emitData();
  }

  validateIpInSubnet (subnet,ips) {
      let __this = this;
      let ipsValid = false;
      let subnetIP = $.trim(subnet[0]);
      let netMask  = $.trim(subnet[1]);
      ips.forEach(function(el){
          if (!__this.ipValidationUtils.isIpValid(el['startAddress']) || !__this.ipValidationUtils.isIpValid(el['endAddress'])) {
              return !ipsValid;
          }
          ipsValid = __this.ipValidationUtils.areAllIpInRanges(el['startAddress'], el['endAddress'],subnetIP, netMask );
          return !ipsValid;
     });
      return ipsValid;
    }

  computeRangeData(subnets, subIPRanges) {
      let ret = [];
      let __this = this;

      subnets.map(function(subnetItem, index){
                var _index = index;
                subnetItem.ipRanges = [];
                subIPRanges.map(function(ipRange, idx){
                    var ipRanges = [];
                    ipRanges.push(ipRange);
                    var inSubnet = __this.validateIpInSubnet([subnetItem.gatewayAddress, subnetItem.maskBits], ipRanges);
                    if(inSubnet){
                        subnetItem.ipRanges.push(ipRange);
                    }
                });
                ret.push(subnetItem);
      });
      return ret;
  }

  validateIPRange() {
    let found = false;
    let mainSubnets: any;
    if (this.isNetworkCreatedNow) {
      mainSubnets = $.extend(true, [], [this.networkDetail.subnets[0]]);
    } else {
      mainSubnets = $.extend(true, [], this.createData.subnets);
    }

    let subIPRanges = $.extend(true, [], this.dataModel.ipRanges);
    let subnets = this.computeRangeData(mainSubnets, subIPRanges);
    for (let i=0; i<subnets.length; i++) {
      if (subnets[i].ipRanges.length > 0) {
          found = true;
      }
    }
    return found;
  }

  setIpRanges(event) {
    this.dataModel.ipRanges = (event.data) ? $.extend(true, [], event.data) : [];
    this.dataModel.isStepValid = this.validateIPRange();
    this.emitData();
  }

  emitData() {
    this.stepEventEmitter.emit(this.dataModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/wizards/connect-gateway/steps/configure-gateway.component.ts